// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"5531e6fe","453":"4321e4ab","457":"69b0190b","551":"091c84bb","760":"ace4856a","849":"6fa21dbc","893":"043c9fe0","940":"333a16e1"}[chunkId] + ".chunk.js";
};